import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Dropdown from 'atoms/Dropdown/Dropdown';
import Input from 'atoms/Input/Input';
import ComponentsList from 'containers/Components/ComponentsList';
import useDebounceCallback from 'hooks/useDebounceCallback';
import ChevronDownSvg from 'images/v5/icons/chevron-down.svg';
import FilterSvg from 'images/v5/icons/filter-lines.svg';
import PlusSvg from 'images/v5/icons/plus.svg';
import LoopSvg from 'images/v5/icons/search-md.svg';
import Button from 'layout/atoms/Button/Button';
import Header from 'layout/atoms/Header/Header';
import FiltersBar from 'layout/molecules/FiltersBar/FiltersBar';
import Grid from 'layout/molecules/Grid/Grid';
import { setFilter } from 'store/componentsSlice';
import { openModal } from 'store/layoutSlice';
import { selectSpecificationComponentsCategory } from 'store/specificationComponentsSlice';
function Components() {
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const category = useSelector(selectSpecificationComponentsCategory);
    const filters = useSelector((state) => state.components.filters);
    const suppliersStatus = useSelector((state) => state.components.suppliers.status);
    const suppliersItems = useSelector((state) => state.components.suppliers.items);
    const debouncedSearch = useDebounceCallback((searchQuery) => {
        dispatch(setFilter({ filterName: 'name', value: searchQuery }));
    }, 1000);
    const statusOptions = [
        {
            text: 'common:all_v1',
            value: null,
        },
        {
            text: 'status_active',
            value: 'ACTIVE',
        },
        {
            text: 'status_archived',
            value: 'ARCHIVED',
        },
    ];
    const handleSearchFilter = (e) => {
        const newQuery = e.target.value;
        debouncedSearch(newQuery);
    };
    const handleStatusFilterChange = (value) => {
        if (filters.statusId === value) {
            dispatch(setFilter({ filterName: 'statusId', value: null }));
        }
        else {
            dispatch(setFilter({ filterName: 'statusId', value }));
        }
    };
    const handleSupplierFilterChange = (value) => {
        if (filters.supplierId === value) {
            dispatch(setFilter({ filterName: 'supplierId', value: null }));
        }
        else {
            dispatch(setFilter({ filterName: 'supplierId', value }));
        }
    };
    const handleCreatorOpen = () => {
        dispatch(openModal({
            name: 'componentCreator',
            data: { predefinedCategory: category.id },
        }));
    };
    return (React.createElement(Grid, null,
        React.createElement(Header, { size: "m" }, category === null || category === void 0 ? void 0 : category.name),
        React.createElement(FiltersBar, { noPadding: true, mainButton: React.createElement(Button, { color: "primary", leftIcon: React.createElement(PlusSvg, null), onClick: handleCreatorOpen }, t('add_component')), searchInput: React.createElement(Input, { size: "s", leftIcon: React.createElement(LoopSvg, null), placeholder: t('common:search'), onChange: (e) => handleSearchFilter(e) }) },
            React.createElement(Dropdown, { trigger: React.createElement(Button, { theme: "border", leftIcon: React.createElement(FilterSvg, null), rightIcon: React.createElement(ChevronDownSvg, null) }, t('status')) }, statusOptions.map((status) => (React.createElement(Button, { key: status.text, align: "left", theme: filters.statusId === status.value ? 'fill' : 'ghost', onClick: () => handleStatusFilterChange(status.value) }, t(status.text))))),
            React.createElement(Dropdown, { trigger: React.createElement(Button, { theme: "border", leftIcon: React.createElement(FilterSvg, null), rightIcon: React.createElement(ChevronDownSvg, null) }, (filters.supplierId &&
                    suppliersItems.find((item) => item.id === filters.supplierId).shortName) ||
                    t('supplier')) }, suppliersStatus === 'succeeded'
                ? suppliersItems.map((supplier) => (React.createElement(Button, { key: supplier.id, align: "left", theme: filters.supplierId === supplier.id ? 'fill' : 'ghost', onClick: () => handleSupplierFilterChange(supplier.id), disabled: supplier.status !== 'ACTIVE' }, supplier.shortName)))
                : 'loading')),
        React.createElement(ComponentsList, { category: category, scrollableTarget: "modal-content-component-list", selectable: true })));
}
export default memo(Components);
